import React, { useState, useEffect } from 'react';

import GoogleMap from 'google-map-react';
import { fitBounds } from 'google-map-react/utils';

import { EstateTeaser } from '/components/estate-teaser/EstateTeaser';

const googleMapStyles = [
    {
        "featureType": "all",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "weight": "0.5"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text",
        "stylers": [
            {
                "lightness": "-50"
            },
            {
                "saturation": "-50"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text",
        "stylers": [
            {
                "hue": "#009aff"
            },
            {
                "saturation": "25"
            },
            {
                "lightness": "0"
            },
            {
                "visibility": "simplified"
            },
            {
                "gamma": "1"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "saturation": "0"
            },
            {
                "lightness": "100"
            },
            {
                "gamma": "2.31"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "lightness": "20"
            },
            {
                "gamma": "1"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": "-100"
            },
            {
                "lightness": "-100"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": "0"
            },
            {
                "saturation": "45"
            },
            {
                "gamma": "4.24"
            },
            {
                "visibility": "simplified"
            },
            {
                "hue": "#00ff90"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "saturation": "-100"
            },
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "color": "#666666"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "labels.icon",
        "stylers": [
            {
                "saturation": "-25"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "transit.station.airport",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "lightness": "50"
            },
            {
                "gamma": ".75"
            },
            {
                "saturation": "100"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    }
];

const getCenterAndZoom = (hits) => {
    const xxx = hits.filter(hit => hit.latitude && hit.longitude);

    if (xxx.length === 0) {
        return;
    }

    if (xxx.length === 1) {
        const first = hits[0];

        return {
            center: {
                lat: +first.latitude,
                lng: +first.longitude,
            },
            zoom: 12,
        };
    }

    const latitudes = [];
    xxx.forEach((hit) => {
        if (latitudes.includes(+hit.latitude) === false) {
            latitudes.push(+hit.latitude);
        }
    });
    const longitudes = [];
    xxx.forEach((hit) => {
        if (longitudes.includes(+hit.longitude) === false) {
            longitudes.push(+hit.longitude);
        }
    });

    if (latitudes.length === 1 && longitudes.length === 1) {
        return {
            center: {
                lat: latitudes[0],
                lng: longitudes[0],
            },
            zoom: 12,
        }
    }

    const mapBCR = document.querySelector('.estate-search-results-map').getBoundingClientRect();

    const bounds = {
        nw: {
            lat: Math.max(...latitudes),
            lng: Math.min(...longitudes),
        },
        se: {
            lat: Math.min(...latitudes),
            lng: Math.max(...longitudes),
        },
    };

    const size = {
        width: mapBCR.width,
        height: mapBCR.height,
    };

    return fitBounds(bounds, size);
};

const MapTeaser = ({ estate, active, onClick }) => {
    const classNames = ['estate-search-results-map-result'];

    if (active) {
        classNames.push('is-active');
    }

    return (
        <div className={classNames.join(' ')}>
            {active && (
                <div className="estate-search-results-map-result__teaser">
                    <button className="estate-search-results-map-result__close" onClick={onClick}>
                        <div className="close-icon">
                            <span className="close-icon__bar" />
                            <span className="close-icon__bar" />
                        </div>
                    </button>
                    <EstateTeaser estate={estate} />
                </div>
            )}
            <button className="estate-search-results-map-result__marker" type="button" onClick={onClick}>
                <svg viewBox="0 0 22 27">
                    <path d="M11 0A11 11 0 000 11c0 7.23 7.15 10.7 8.05 11.5.91.83 1.67 2.67 1.97 3.72.15.5.57.76.98.77.41 0 .83-.27.98-.77.3-1.05 1.06-2.9 1.97-3.72.9-.8 8.05-4.27 8.05-11.5A11 11 0 0011 0z" />
                    <path fill="#FFF" d="M11 14a3 3 0 110-6 3 3 0 010 6z" />
                </svg>
            </button>
        </div>
    );
};

const EstateSearchResultsMap = ({ hits }) => {
    const [center, setCenter] = useState(null);
    const [zoom, setZoom] = useState(12);

    const [activeHit, setActiveHit] = useState(null);

    window.setActiveHitId = (id) => {
        setActiveHit({
            id,
        });
    };

    const handleMarkerClick = (hit) => {
        if (activeHit && activeHit.id === hit.id) {
            setActiveHit(null);
            return;
        }

        setActiveHit(hit);
    };

    useEffect(() => {
        const xxx = getCenterAndZoom(hits);
        const {
            enableFixedPosition,
            fixedPosition,
        } = window.estateOverview;

        if (enableFixedPosition) {
            if (center === null) {
                setCenter({
                    lat: fixedPosition.lat,
                    lng: fixedPosition.lng,
                });
                setZoom(window.innerWidth <= 768 ? fixedPosition.mobileZoom : fixedPosition.desktopZoom);
            }
        } else if (xxx) {
            setCenter(xxx.center);
            setZoom(xxx.zoom);
        }
    }, [hits]);

    useEffect(() => {
        if (activeHit && activeHit.id) {
            const estate = hits.find(hit => hit.id === activeHit.id);

            if (estate) {
                setCenter({
                    lat: estate.latitude,
                    lng: estate.longitude,
                });
            }
        }
    }, [activeHit]);

    return (
        <div className="estate-search-results-map">
            <GoogleMap
                bootstrapURLKeys={{ key: process.env.GOOGLE_MAPS_API_KEY }}
                center={center}
                zoom={zoom}
                key="google-map"
                options={{ styles: googleMapStyles }}
            >
                {hits.filter(hit => hit.latitude && hit.longitude).map((hit) => (
                    <MapTeaser
                        active={activeHit && activeHit.id === hit.id}
                        estate={hit}
                        key={hit.id}
                        lat={+hit.latitude}
                        lng={+hit.longitude}
                        onClick={() => { handleMarkerClick(hit); }}
                    />
                ))}
            </GoogleMap>
        </div>
    );
};

export { EstateSearchResultsMap };
